import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/Users/kei/repos/opera-lang/src/components/Layout.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Note = makeShortcode("Note");
const Part = makeShortcode("Part");
const Ex = makeShortcode("Ex");
const Translation = makeShortcode("Translation");
const LyricSeparator = makeShortcode("LyricSeparator");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`カルタの歌（カルメン）`}</h1>
    <h4>{`Mêlons ! Coupons !`}</h4>
    <p>{`ジプシー女たちの三重唱。メルセデス、フラスキータの陽気な恋占いの歌と、カルメンの死を予言する暗く重い歌の対比が印象的。`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#youtube"
        }}>{`Youtube の動画`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#translation"
        }}>{`対訳と語義解説`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#sheet"
        }}>{`楽譜`}</a></li>
    </ul>
    <h2 name="youtube">Youtube の動画</h2>
    <h4>{`Carmen - Melons! Coupons! (Subtítulos español)`}</h4>
    <iframe width="100%" height="315" src="https://www.youtube.com/embed/maNRozGyCOw" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
    <h4>{`Carmen Trio des cartes Scala de Milan 7 12 2009 live Google Chrome`}</h4>
    <iframe width="100%" height="315" src="https://www.youtube.com/embed/B9RLIRTxBro" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
    <h2 name="translation">対訳と語義解説</h2>
    <Note mdxType="Note">単語をクリック（タップ）すると解説が表示されます。</Note>
    <Part mdxType="Part">Mercédès et Frasquita (メルセデスとフラスキータ)</Part>
    <p>
  <Ex m="混ぜる（一人称複数の命令法「〜しよう」）" o="mêler" mdxType="Ex">
    Mêlons
  </Ex>{" "}
  ! Mêlons ! <Ex m="切る（一人称複数の命令法「〜しよう」）" mdxType="Ex">Coupons</Ex> !
  Coupons !
    </p>
    <Translation mdxType="Translation">混ぜて！ 切って！</Translation>
    <p>Bien! c'est cela! Bien! c'est cela!</p>
    <Translation mdxType="Translation">よし、これでいい</Translation>
    <p>
  <Ex m="3" mdxType="Ex">Trois</Ex> <Ex m="カード" mdxType="Ex">cartes</Ex> <Ex m="ここに" mdxType="Ex">ici</Ex>, Trois
  cartes ici,
    </p>
    <Translation mdxType="Translation">こっちに３枚</Translation>
    <p>
  <Ex m="4" mdxType="Ex">Quatre</Ex> <Ex m="あちらに、そちらに" mdxType="Ex">là</Ex> ! Quatre là !
    </p>
    <Translation mdxType="Translation">あっちに４枚</Translation>
    <LyricSeparator mdxType="LyricSeparator" />
    <p>
  Et{" "}
  <Ex m="今（英語のnowと同じように話題の転換などにも用いる。「さあ、さて」）" mdxType="Ex">
    maintenant
  </Ex>
  , <Ex m="話す（命令）" o="parler" mdxType="Ex">
    parlez
  </Ex> <Ex m="「ねえ」カードたちへの呼びかけ。直訳すると「私のかわいこちゃんたち」くらいの意味。les cartesに性・数一致（女性・複数）している" mdxType="Ex">
    mes belles
  </Ex>,
    </p>
    <Translation mdxType="Translation">さあ、教えて、カードたち</Translation>
    <p>
  <Ex m="このdeはparlerの間接目的。parler de 〜「〜について話す」" mdxType="Ex">De</Ex>{" "}
  <Ex m="未来" mdxType="Ex">l'avenir</Ex>,{" "}
  <Ex m="私たちに与えてください（命令法）" o="donner" mdxType="Ex">
    donnez-nous
  </Ex>{" "}
  <Ex m="知らせ、ニュース" mdxType="Ex">des nouvelles</Ex>,
    </p>
    <Translation mdxType="Translation">未来のこと、私たちに知らせておくれ</Translation>
    <p>
  <Ex m="私たちに言ってください（命令法）" o="dire" mdxType="Ex">
    Dites-nous
  </Ex>{" "}
  <Ex m="誰が（英語のwho" mdxType="Ex">qui</Ex> <Ex m="私たちを" mdxType="Ex">nous</Ex>{" "}
  <Ex m="裏切る（未来）" o="trahir" mdxType="Ex">
    trahira
  </Ex>{" "}
  ! Dites-nous qui nous trahira !
    </p>
    <Translation mdxType="Translation">誰が裏切るのか言っておくれ</Translation>
    <p>
  Dites-nous qui nous{" "}
  <Ex m="愛する（未来）" o="aimer" mdxType="Ex">
    aimera
  </Ex>{" "}
  ! Dites-nous qui nous aimera !
    </p>
    <Translation mdxType="Translation">誰が愛してくれるのか言っておくれ</Translation>
    <p>
  <Ex m="話す（命令法）" mdxType="Ex">Parlez</Ex>, parlez ! Parlez, parlez !
    </p>
    <Translation mdxType="Translation">教えて、教えて！</Translation>
    <p>Dites-nous qui nous trahira,</p>
    <Translation mdxType="Translation">誰が裏切るのか言っておくれ</Translation>
    <p>Dites-nous qui nous aimera !</p>
    <Translation mdxType="Translation">誰が愛してくれるのか言っておくれ</Translation>
    <p>Parlez ! Parlez ! Parlez ! Parlez !</p>
    <Translation mdxType="Translation">教えて！ 教えて！</Translation>
    <LyricSeparator mdxType="LyricSeparator" />
    <Part mdxType="Part">Frasquita (フラスキータ)</Part>
    <p>
  <Ex m="私は（文法上の主語ではなく、強調、対比（あなたではなく私）のために文頭に置く。会話の始めによく使われる）" mdxType="Ex">
    Moi
  </Ex>
  , <Ex m="私は（こちらが文法上の主語）" mdxType="Ex">je</Ex> <Ex m="見る、見える" o="voir" mdxType="Ex">
    vois
  </Ex> un <Ex m="若い" mdxType="Ex">jeune</Ex> <Ex m="恋人" mdxType="Ex">amoureux</Ex>
    </p>
    <Translation mdxType="Translation">私には、若い恋人が見えるわ</Translation>
    <p>
  <Ex m="amoureuxに係る関係代名詞（英語のwho）" mdxType="Ex">Qui</Ex>{" "}
  <Ex m="私を愛する(m' = me 私を)" o="aimer" mdxType="Ex">
    m'aime
  </Ex>{" "}
  <Ex m="この上なく（= on ne peut mieux）" mdxType="Ex">on ne peut davantage</Ex>
    </p>
    <Translation mdxType="Translation">この上なく私を愛してくれる</Translation>
    <Part mdxType="Part">Mercédès (メルセデス)</Part>
    <p>
  <Ex m="私のもの（英語のmineに相当。ここではフラスキータが自分の恋人について語ったことを受けて、 mon amoureux「私の恋人」）" mdxType="Ex">
    Le mien
  </Ex>{" "}
  est <Ex m="非常に裕福な" mdxType="Ex">très-riche</Ex> et{" "}
  <Ex m="非常に年老いた" mdxType="Ex">très-vieux</Ex>
    </p>
    <Translation mdxType="Translation">私のは大金持ちのお爺さん</Translation>
    <p>
  <Ex m="しかし" mdxType="Ex">Mais</Ex> <Ex m="彼は" mdxType="Ex">il</Ex>{" "}
  <Ex m="〜について話す" o="parler" mdxType="Ex">
    parle de
  </Ex>{" "}
  <Ex m="結婚" mdxType="Ex">mariage</Ex> !
    </p>
    <Translation mdxType="Translation">それでも結婚しようですって！</Translation>
    <Part mdxType="Part">Frasquita (フラスキータ)</Part>
    <p>
  <Ex m="彼は" mdxType="Ex">Il</Ex> <Ex m="私を" mdxType="Ex">me</Ex>{" "}
  <Ex m="しっかりと置く" o="camper" mdxType="Ex">
    campe
  </Ex>{" "}
  <Ex m="〜の上に" mdxType="Ex">sur</Ex> <Ex m="彼の" mdxType="Ex">son</Ex> <Ex m="馬" mdxType="Ex">cheval</Ex>
    </p>
    <Translation mdxType="Translation">彼は私を馬に乗せて</Translation>
    <p>
  Et <Ex m="〜の中に" mdxType="Ex">dans</Ex> <Ex m="山" mdxType="Ex">la montagne</Ex> il{" "}
  <Ex m="私を連れて行く（m' = me 私を）" o="entraîner" mdxType="Ex">
    m'entraîne
  </Ex>{" "}
  !
    </p>
    <Translation mdxType="Translation">山の中に連れて行く！</Translation>
    <Part mdxType="Part">Mercédès (メルセデス)</Part>
    <p>
  <Ex m="〜の中に" mdxType="Ex">Dans</Ex> <Ex m="城" mdxType="Ex">un château</Ex>{" "}
  <Ex m="ほとんど" mdxType="Ex">presque</Ex> <Ex m="王の" mdxType="Ex">royal</Ex>,
    </p>
    <Translation mdxType="Translation">王宮みたいなお城で、</Translation>
    <p>
  <Ex m="私のもの（英語のmineに相当。ここでは私の恋人）" mdxType="Ex">Le mien</Ex>{" "}
  <Ex m="私を住まわせる（m' = me 私を）" o="installer" mdxType="Ex">
    m'installe
  </Ex>{" "}
  <Ex m="君主の座に" mdxType="Ex">en souveraine</Ex> !
    </p>
    <Translation mdxType="Translation">私は女王様のような暮らし！</Translation>
    <Part mdxType="Part">Frasquita (フラスキータ)</Part>
    <p>
  De l'amour <Ex m="果てしない" mdxType="Ex">à n'en plus finir</Ex>,
    </p>
    <Translation mdxType="Translation">果てしない恋に</Translation>
    <p>
  <Ex m="毎日" mdxType="Ex">Tous les jours</Ex>, <Ex m="新しい" mdxType="Ex">nouvelles</Ex>{" "}
  <Ex m="熱中、情熱" mdxType="Ex">folies</Ex> !
    </p>
    <Translation mdxType="Translation">来る日も来る日も新しい情熱！</Translation>
    <Part mdxType="Part">Mercédès (メルセデス)</Part>
    <p>
  <Ex m="黄金" mdxType="Ex">De l'or</Ex>{" "}
  <Ex m="持てるだけの（訳では「持ちきれないほどの」としたが、本来否定の意味はない）" mdxType="Ex">
    tant que j'en puis tenir
  </Ex>
  ,
    </p>
    <Translation mdxType="Translation">持ちきれないほどの黄金</Translation>
    <p>
  <Ex m="ダイアモンド" mdxType="Ex">Des diamants</Ex>, <Ex m="宝石" mdxType="Ex">des pierreries</Ex> !
    </p>
    <Translation mdxType="Translation">ダイアモンドに宝石も！</Translation>
    <Part mdxType="Part">Frasquita (フラスキータ)</Part>
    <p>
  Le mien <Ex m="〜になる" mdxType="Ex">devient</Ex> <Ex m="長、頭（かしら）" mdxType="Ex">un chef</Ex>{" "}
  <Ex m="有名な" mdxType="Ex">fameux</Ex>,
    </p>
    <Translation mdxType="Translation">私の彼は有名な親分になる</Translation>
    <p>
  <Ex m="100" mdxType="Ex">Cent</Ex> <Ex m="男" mdxType="Ex">hommes</Ex>{" "}
  <Ex m="歩く" o="marcher" mdxType="Ex">
    marchent
  </Ex>{" "}
  <Ex m="彼のあとに続いて（sa 「彼の」）" mdxType="Ex">à sa suite</Ex> !
    </p>
    <Translation mdxType="Translation">100人の手下たちが彼に続く！</Translation>
    <Part mdxType="Part">Mercédès (メルセデス)</Part>
    <p>
  Le mien... le mien...{" "}
  <Ex m="我が目を疑う（否定文 ne pas en croire ses yeuxの形で使われることが多いがここでは疑問文になっている）" mdxType="Ex">
    en croirai-je mes yeux
  </Ex>{" "}
  ?
    </p>
    <Translation mdxType="Translation">私の彼は、私の彼は、信じられないわ</Translation>
    <p>
  oui... Il{" "}
  <Ex m="死ぬ" o="mourir" mdxType="Ex">
    meurt
  </Ex>{" "}
  ! Ah ! je suis <Ex m="未亡人" mdxType="Ex">veuve</Ex> et{" "}
  <Ex m="相続する" o="hériter" mdxType="Ex">
    j'hérite
  </Ex>{" "}
  !
    </p>
    <Translation mdxType="Translation">そうよ、死ぬんだわ！ 私は未亡人で、遺産がたんまり！</Translation>
    <Part mdxType="Part">Mercédès et Frasquita (メルセデスとフラスキータ)</Part>
    <p>
  Parlez <Ex m="もう一度（現代フランス語ではencoreと綴る）" mdxType="Ex">encor</Ex>, parlez
  mes belles,
    </p>
    <Translation mdxType="Translation">もう一度教えて、カードたち</Translation>
    <p>De l'avenir, donnez-nous des nouvelles,</p>
    <Translation mdxType="Translation">未来のこと、私たちに知らせておくれ</Translation>
    <p>Dites-nous qui nous trahira ! Dites-nous qui nous trahira !</p>
    <Translation mdxType="Translation">誰が裏切るのか言っておくれ</Translation>
    <p>Dites-nous qui nous aimera ! Dites-nous qui nous aimera !</p>
    <Translation mdxType="Translation">誰が愛してくれるのか言っておくれ</Translation>
    <p>Parlez, parlez ! Parlez, parlez !</p>
    <Translation mdxType="Translation">教えて、教えて！</Translation>
    <p>Dites-nous qui nous trahira,</p>
    <Translation mdxType="Translation">誰が裏切るのか言っておくれ</Translation>
    <p>Dites-nous qui nous aimera !</p>
    <Translation mdxType="Translation">誰が愛してくれるのか言っておくれ</Translation>
    <Part mdxType="Part">Mercédès (メルセデス)</Part>
    <p>Fortune !</p>
    <Translation mdxType="Translation">財産！</Translation>
    <Part mdxType="Part">Frasquita (フラスキータ)</Part>
    <p>Amour !</p>
    <Translation mdxType="Translation">恋！</Translation>
    <LyricSeparator mdxType="LyricSeparator" />
    <Part mdxType="Part">Carmen (カルメン)</Part>
    <p>
  Voyon, que j'
  <Ex m="試す" o="essayer" mdxType="Ex">
    essaie
  </Ex> à <Ex m="私の" mdxType="Ex">mon</Ex> <Ex m="順番" mdxType="Ex">tour</Ex>,
    </p>
    <Translation mdxType="Translation">さあ、今度は私がやってみるわ</Translation>
    <p>
  <Ex m="トランプのダイヤ" mdxType="Ex">Carreau</Ex> ! <Ex m="トランプのスペード" mdxType="Ex">Pique</Ex>{" "}
  !
    </p>
    <Translation mdxType="Translation">ダイヤ！ スペード！</Translation>
    <p>
  <Ex m="死" mdxType="Ex">La mort</Ex> ! j'
  <Ex m="動詞の過去分詞（ここではlu）と合わせて複合過去形を作る" o="avoir" mdxType="Ex">
    ai
  </Ex> bien <Ex m="読む（avoir lu 複合過去）" o="lire" mdxType="Ex">
    lu
  </Ex>
  ... <Ex m="私" mdxType="Ex">moi</Ex> <Ex m="最初に" mdxType="Ex">d'abord</Ex>,
    </p>
    <Translation mdxType="Translation">死だわ！ 読めた… まず私、</Translation>
    <p>
  <Ex m="それから、次に" mdxType="Ex">Ensuite</Ex> <Ex m="彼" mdxType="Ex">lui</Ex>...{" "}
  <Ex m="〜にとって（英語のfor）" mdxType="Ex">pour</Ex>{" "}
  <Ex m="ふたりとも" mdxType="Ex">tous les deux</Ex>, la mort !
    </p>
    <Translation mdxType="Translation">それから彼、ふたりとも、死ぬのよ！</Translation>
    <LyricSeparator mdxType="LyricSeparator" />
    <p>
  <Ex m="無駄に" mdxType="Ex">En vain</Ex>{" "}
  <Ex m="〜するために（この2行の直訳は「苦い答えを避けるために、君は無駄に混ぜるだろう」）" mdxType="Ex">
    pour
  </Ex>{" "}
  <Ex m="避ける" mdxType="Ex">éviter</Ex> <Ex m="答え、返答（複数）" mdxType="Ex">les réponses</Ex>{" "}
  <Ex m="苦い" mdxType="Ex">amères</Ex>,
    </p>
    <Translation mdxType="Translation">不吉な答えを避けようとしても無駄</Translation>
    <p>
  En vain <Ex m="君は（ここでは漠然とした主語）" mdxType="Ex">tu</Ex>{" "}
  <Ex m="混ぜる（未来）" o="mêler" mdxType="Ex">
    mêleras
  </Ex>
  ,
    </p>
    <Translation mdxType="Translation">混ぜても無駄</Translation>
    <p>
  <Ex m="それ（= 混ぜること）" mdxType="Ex">Cela</Ex>{" "}
  <Ex m="なんの役にも立たない（ne ... rien 何も...ない、 servir à 〜の役に立つ）" mdxType="Ex">
    ne sert à rien
  </Ex>
  , les cartes <Ex m="〜である（英語のbe動詞）" mdxType="Ex">sont</Ex> <Ex m="誠実な" mdxType="Ex">sincères</Ex>
    </p>
    <Translation mdxType="Translation">なんにもならない、カードは誠実</Translation>
    <p>
  Et ne{" "}
  <Ex m="嘘をつく（未来０" o="mentir" mdxType="Ex">
    mentiront
  </Ex>{" "}
  pas !
    </p>
    <Translation mdxType="Translation">嘘はつかない</Translation>
    <p>
  <Ex m="〜の中に" mdxType="Ex">Dans</Ex> <Ex m="本" mdxType="Ex">le livre</Ex>{" "}
  <Ex m="天の、神の" mdxType="Ex">d'en haut</Ex>, <Ex m="もし（英語のif）" mdxType="Ex">si</Ex>{" "}
  <Ex m="君の" mdxType="Ex">ta</Ex> <Ex m="ページ" mdxType="Ex">page</Ex>{" "}
  <Ex m="〜である（英語のbe動詞）" mdxType="Ex">est</Ex> <Ex m="幸せな" mdxType="Ex">heureuse</Ex>,
    </p>
    <Translation mdxType="Translation">天上の書物に、幸福だと書いてあれば</Translation>
    <p>
  <Ex m="混ぜる（命令）" o="mêler" mdxType="Ex">
    Mêle
  </Ex>{" "}
  et{" "}
  <Ex m="切る" o="couper" mdxType="Ex">
    coupe
  </Ex>{" "}
  <Ex m="〜なしに（英語のwithout）" mdxType="Ex">sans</Ex> <Ex m="恐怖" mdxType="Ex">peur</Ex>,
    </p>
    <Translation mdxType="Translation">怖がらずに混ぜ、切りなさい</Translation>
    <p>
  La carte <Ex m="〜の下に" mdxType="Ex">sous</Ex> <Ex m="君の（複数）" mdxType="Ex">tes</Ex>{" "}
  <Ex m="指" mdxType="Ex">doigts</Ex>{" "}
  <Ex m="向きを変える（ここではカードが「めくられる」）（未来）" o="se tourner" mdxType="Ex">
    se tournera
  </Ex>{" "}
  <Ex m="楽しい" mdxType="Ex">joyeuse</Ex>,
    </p>
    <Translation mdxType="Translation">指の下のカードは楽しげに</Translation>
    <p>
  <Ex m="t' は間接目的補語 te（君に）、annoncer「知らせる」の現在分詞" mdxType="Ex">
    T'annonçant
  </Ex>{" "}
  <Ex m="幸福" mdxType="Ex">le bonheur</Ex> !
    </p>
    <Translation mdxType="Translation">幸福を知らせてくれる</Translation>
    <p>
  <Ex m="しかし（英語のbut）" mdxType="Ex">Mais</Ex> si <Ex m="君は" mdxType="Ex">tu</Ex>{" "}
  <Ex m="〜しなければならない" o="devoir" mdxType="Ex">
    dois
  </Ex>{" "}
  <Ex m="死ぬ" mdxType="Ex">mourir</Ex>,
    </p>
    <Translation mdxType="Translation">でも、死ななければならないのなら、</Translation>
    <p>
  Si <Ex m="言葉、単語" mdxType="Ex">le mot</Ex> <Ex m="恐ろしい" mdxType="Ex">redoutable</Ex>
    </p>
    <Translation mdxType="Translation">恐ろしい言葉が</Translation>
    <p>
  <Ex m="〜である（英語のbe動詞、ここでは受身の文を作っている）" mdxType="Ex">Est</Ex>{" "}
  <Ex m="書く（過去分詞）" o="écrire" mdxType="Ex">
    écrit
  </Ex>{" "}
  <Ex m="〜によって（英語のby）" mdxType="Ex">par</Ex> <Ex m="運命" mdxType="Ex">le sort</Ex>,
    </p>
    <Translation mdxType="Translation">運命によって書かれているのなら、</Translation>
    <p>
  <Ex m="ふたたび始める、繰り返す（命令）" mdxType="Ex">Recommence</Ex> <Ex m="20" mdxType="Ex">vingt</Ex>{" "}
  <Ex m="回" mdxType="Ex">fois</Ex>, la carte <Ex m="非情な、冷酷な" mdxType="Ex">impitoyable</Ex>
    </p>
    <Translation mdxType="Translation">20回やってみても、冷酷なカードは</Translation>
    <p>
  <Ex m="繰り返す（未来）" o="répéter" mdxType="Ex">
    Répétera
  </Ex>
  : la mort !
    </p>
    <Translation mdxType="Translation">「死」と繰り返す！</Translation>
    <p>Oui, si tu dois mourir,</p>
    <Translation mdxType="Translation">そう、死ななければならないのなら、</Translation>
    <p>Recommence vingt fois, la carte impitoyable</p>
    <Translation mdxType="Translation">20回やってみても、冷酷なカードは</Translation>
    <p>Répétera: la mort !</p>
    <Translation mdxType="Translation">「死」と繰り返す！</Translation>
    <p>
  Encor ! Encor ! <Ex m="いつも" mdxType="Ex">Toujours</Ex> la mort !
    </p>
    <Translation mdxType="Translation">もう一度！ もう一度！ 何度やっても「死」！</Translation>
    <LyricSeparator mdxType="LyricSeparator" />
    <Part mdxType="Part">Mercédès et Frasquita (メルセデスとフラスキータ)</Part>
    <p>Parlez encor, parlez mes belles,</p>
    <Translation mdxType="Translation">もう一度教えて、カードたち</Translation>
    <p>De l'avenir, donnez-nous des nouvelles,</p>
    <Translation mdxType="Translation">未来のこと、私たちに知らせておくれ</Translation>
    <p>
  <Part mdxType="Part">M et F</Part>Dites-nous qui nous trahira ! Dites-nous qui nous trahira !
    </p>
    <p>
  <Part mdxType="Part">Carmen (カルメン)</Part>Encor !
    </p>
    <Translation mdxType="Translation">誰が裏切るのか言っておくれ</Translation>
    <Translation mdxType="Translation">もう一度！</Translation>
    <p>
  <Part mdxType="Part">M et F</Part>Dites-nous qui nous aimera ! Dites-nous qui nous aimera !
    </p>
    <p>
  <Part mdxType="Part">C</Part>Encor !
    </p>
    <Translation mdxType="Translation">誰が愛してくれるのか言っておくれ</Translation>
    <Translation mdxType="Translation">もう一度！</Translation>
    <p>
  <Part mdxType="Part">M et F</Part>Parlez, encor ! Parlez, encor !
    </p>
    <p>
  <Part mdxType="Part">C</Part>
  <Ex m="絶望" mdxType="Ex">Le désespoir</Ex> !
    </p>
    <Translation mdxType="Translation">もう一度教えて！</Translation>
    <Translation mdxType="Translation">絶望！</Translation>
    <p>
  <Part mdxType="Part">M et F</Part>Dites-nous qui nous trahira,
    </p>
    <p>
  <Part mdxType="Part">C</Part>La mort ! La mort !
    </p>
    <Translation mdxType="Translation">誰が裏切るのか言っておくれ</Translation>
    <Translation mdxType="Translation">死！ 死！</Translation>
    <p>
  <Part mdxType="Part">M et F</Part>Dites-nous qui nous aimera !
    </p>
    <p>
  <Part mdxType="Part">C</Part>Encor... la mort !
    </p>
    <Translation mdxType="Translation">誰が愛してくれるのか言っておくれ</Translation>
    <Translation mdxType="Translation">もう一度… 死！</Translation>
    <p>
  <Part mdxType="Part">M</Part>Fortune ! <Part mdxType="Part">F</Part>Amour ! <Part mdxType="Part">C</Part>Toujours la mort !
    </p>
    <Translation mdxType="Translation">財産！ 恋！ やっぱり、死！</Translation>
    <p>
  <Part mdxType="Part">M</Part>Fortune ! <Part mdxType="Part">F</Part>Amour ! <Part mdxType="Part">C</Part>Toujours la mort !
    </p>
    <Translation mdxType="Translation">財産！ 恋！ やっぱり、死！</Translation>
    <p>Encor ! encor ! encor ! encor !</p>
    <Translation mdxType="Translation">もう一度！ もう一度！</Translation>
    <h2 name="sheet">楽譜</h2>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "800px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/84318e11da87e4d6710731be386c38e8/8698d/carmen-trio.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "691%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAACKCAYAAACq5Wo+AAAACXBIWXMAABcSAAAXEgFnn9JSAAAMbElEQVRo3qXah64WtxaGYe7/llAkmgihJ0DoLUDovdeJHh+9luegI0U6W/KeGY9n+fPqXv4PbP/n39evX7cvX76M9uPHj+2Af9++fRvt/fv326dPn8a9AZ8/f573PjT2+/fv41m/vpcvX26vX7/e3rx5M/oOGPDo0aPt6dOn26FDh7ZTp05tz58/327fvr1dunRpe/Lkyfbs2bPt77//3v7888/tr7/+GmMRuXXr1nb8+PHt6tWr472JBkJ/CBvw9u3bMfPHjx/HRFCH0kevXr0aq/Ae4YcPH46riQdCBH3oxeHDhwfCP/74Y3v8+PH42CSQ3rt3b6Dy4dGjR7fTp0+PVXj27vLly/9BCB1eGfz7778PFIhBBsWHDx/GZHjk+d27d4MI3unTjNU/EEbQgN9++22gQxy6Fy9ejH73PXuXIOr3jO/oDIJmSEr4h0deuq9BV3/vXPVrvieHQfD8+fPbsWPHBi9IFJO1+/fvDx5euXJlu3DhwrhCY9zdu3e3mzdvDgkbg4cID4J37twZAyCMnwjjlWW2LHzS8NmE+j0j5P3kIb5BCZGZCOfs2bNjIgMR9067cePGkC6U+NaKdgjxkP5Bh09ZC57glXtI9JuA5FtJQsNDf5OHJ06cGB9BhS9Uh37iEyQQ0UcI9bGaX375Zbt27dq4h9rkg+CDBw/GbP4QhRZ8CKFPoggbl97Rz9QF+onwzJkz26+//jpgmx3TCcQHJsMjCC9evDiaFZD4wYMHx8rOnTs3kE6h4IlZu7dcvDGrSSCEWvNe37oSqD1PhHhw8uTJgQI6KpSuQeMeYvaLj/p5Hf14Cp3305YxlHKaid6lg4gTEuGQJLVByDussBJsMQ7aaSl4gBfxarUA9yZECN/SPcRMjpjGS+30EAJXg8zmQ0tLqq76853cXo0wrGIKBV9IL0X10vJ4YxYAoaWnh1mPSS0ZC6xkIvSBJZgtb6LFN8Sww0RQk/TqmVyNnYpND0nZ4DwHNIhREWiwAhIawdaNvX79+uCrsRrig2DxAXMtoSVBiV/ZtRXgp6VCW4yxOpNNKZMoKWW76SHi7tk6BPQNIivSh58alhg/EVqmFy0r3fKcmiCMBQRHB2uIGQ/MVOz00AAIs2e6l9fW0k1joYVKM8a3E2H654p/OQeo8Kj4m3CKw57zOPonD81AYgi5R4gq+dBgLYvwISFE1BVqMQegKRQdxRBELYUHyRO5xwLscC1mF/Hw0PMgmJ8zW4KBQoOqDMG7NfVonEno7iSIOik3C+a6QpVLy/cVc/A6lTHOJHPJZqJnhcsyBv0JBR8RbQUJQiNh46ZQEBNKSQ18PESEEkNBYJbtPXVJZYy1ZO+sbkeQ5oPuRcG9eKJlXqmLd/HUOyCmYuNR7of9xkf3Bq28W/Mb7/CtODSTpfSP+6ECBiQUfPNRyUD3xnkuAyuYzSXjFa8SwXQvIk1QxlVumOVwa9P0CIQ/xJfs0/3Kn5xrWUJ2XtK0i3rFD50GZmJ56XxlTjXFhnzl55SygTR9DY8II5Z7ylL0sV2Sxoa2FNgxEeY4DWbX+GkSqNznLy3VhK5lC+WHZWyDoBiBj7nzPEqWUibGegr2Jqa7wFA5q5hCibFiRrumdSdVnl0MNtYEUCJUVJw8tAQzrdsEKFObLMfH2urJaQTiWDEVG7ESxiSXteT3yrqyKgTob7mPvkkQL0Q9LzN+QqBzxZn2eNoap7vqn1Juy1XmhYglJaD8ZNvY8u71Go8HQWhk/RRcBIQsT21mvMxm8bSdExaUD+mfCBFMsS2v7URbsRxBNh5f6y8zm84BOkFKZyaVJE2k0btyGeiNb7PpeyubQrGkcux2U/HGu3VnlTfy3O4qrzN5CIF8xWzu6RYEeAhRyltODal779ecfC4Z3yhpFqCVtJewazkLhLAjp4E92DUR4oEMPwJZR5HOlbTXfbI+bCqxMsGMy8XhfFq5c3/61jxx5bNG6jsHC3KeA8/Mhqf0ES81fa74114Fq3xXtja9Dcq5J9KzLEtiKazGu2JJTrXArr96xE7KZk38tYRU2pY5toty1SDf5dgk7MMqR83c1QoyP1eES/NMhrjVTX9I49ViSprMVvqBP/os3cSVE8omEMNvKCfCDF0jGAjafkEFZfHZGO9zWemt+xlTEEyibBaqPohw1wRS7K7m4DrVxhI5WMQw2cCcQ5twBExa/Mg5rKFgEky32g+XiOcU6FiZhPssZ80j3U9brmC2uqr2IaUmhYFqY5CasJzHdRIsC8Vw/KGklQR8RKpVlcpjIC+9K9BPtZGwS5Yyu9y8CQru+OU9PloBh2rZjTHxLgRA0aZnLT8VS/SlyHkbvM/978p98c5sOYU2i1KUEvpiiIk03yBK4ru43JbMDEmtTH/NrHywlhHcJzTIJ0IuCE9IKtNCEO/aTJYkVeDAU/cQFrx2JYJCQIEeL4u/xV0N4moNbcCBoEoTISlDiCietXsqjBIadHipvxyyoprvjZvOwR/XlYKmW7mteAmNvjVLSxeh3yE8cuTIWHqIyqd7bntmqcaXZIZ0x8OqRz5q95QDzW6TcGW+kqg27ng4TQ//lJzLcSCrmKuVhmQlpSOlzQjvSqY50LYSFdUyJ/zNciCEhN3Ge7wr9M4lk6BlQ+AKUdsN0oZKH7+pefaOyhRKpy2TUklR6VvmVfaQNynYW5WJ8K+i0SxIQqRkalYSDGk5D/uGBN/aQ5cktU0zduphTtLs6z7FYAgiVlnAPZSkzYG0C5h6WAyhuKUj7VBT6CqebSNK77IoHmd6G4gsrcJPHqe6vyWboNhcICt7qNYzEUKRgZfbtJcrfJpgLWLo934NsVOxMzOM5RzM6EqRyxawIpeVAVAXfCZIY6baEEr7PfcYDo2ZoW/DsyadkLZbIBx9u32K2RFIIJ47F6g6B2UmmaNNiJDuFLvihIHlLJS6WIJHua3Qh5Sk20XMzEEYrcJU9bydAB65h849Ani8hlXvJkI37cg7zMp1FUarZcfnQmpJKho7hFU42402ayYIITSVDKzElevLn07FLn+GMnePh82OZzndAvuaTP2E0KwcbFXhpMoKiojpI8Tppe/i4w5hlUqzlP3HI9cKZ9l0FhJaQHZSNiOnaVABSB/elumHMn5VjIQ0NzYRrqc5VGLNm0s2tcoueF25uXRYm+mcweyy8nIJZuXnal8Qdb5XTUxfWe5EGK86wY2HFXUL6ibujKWzKEvVdoHexxCVsVaqr85qiSl77quSVfbt3SRIaTnReOkDAikZr8yXZy9nFIfKzBCdSy5VqxxKLRAqz6n6UeZlPFaY1CRlZxOhDTjTW4+QyrQ6Mu8YSYOw7ZzvOqqbUa9kJ2TV/jui7DQtaf93SABiFwLaSLcZzDkkQf1rfWbNt4s/pXqD4BrpCCB+dCqR2lQprqhbWeGnkmkH1C0L/9ZyFV6VT3dsZIzlt+yf9inVVdvTkXpllAJY5tgpRWWF2iQIIadguaQITYdcmWDLjIcEV2mmfeDUw34lsFYw12px2djKxwoeFYKg3Z2AQ1Q9phpsSXmpSulJ24nODtaYNA9oMF8nlbHslpditz/OYkpVWtXukCupmrESaXlgW1vLb9vbaW+eG8Hd2WjpbklPyNrv6a+6lBJnNTmM3QENdCEyGyTrMUdI1rCKDd0nwB1Bip2NFpRKOUrf8swdtHaEWX44nUOK2nlKP5YoLnee3C+DZFn4VbRMNycP8aCibnWYThq9q/gNUblMRcv1/G9aSmkHNJVBW6LBJoO6jZGxLTO+a5NgRZ0K4uleiboP6aePOmFDuMQ93k/TozK5dR9apqXhYXpZPSx7T0BrAj8RdgCTWfXTjnxeiWVep2OPkoCC285j41NZVuf0+rEi72JMdgxRuWTZw7TlvHWq0s6qk0WIOmCtOlzylBH4bibthCJxXI8zOu9cK0cF+lK99adb2lwytSG9VKKzkwqSLbkkqh8GrL8P2+U2FSLLEki02nbeJZ6S/nrU2VlA3+zKLP1aqspwQauC4+r7KlZWsNwhjG8+qjpMpyo3p0qVVNoF0MdclxXMDNYMlDvHiX/FjdI59+vBjYkqQbcJ8jyrcyyECrSHS3oJBtEy2DUErL+QnIcLGI1oAwimOmG+MceRd9Fv2esvJuehf7WZDrEqB3hO37KiEK4xuueJsN1n5flVB/vFVAjTxVxcXsl7RAfBlkGyeeH0rDPQPM/6GybjVnMdarMexPybv/XwpurS+ndgHfRv2v+aoFLVP3A1XbRZJ11oAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "楽譜",
            "title": "楽譜",
            "src": "/static/84318e11da87e4d6710731be386c38e8/5a190/carmen-trio.png",
            "srcSet": ["/static/84318e11da87e4d6710731be386c38e8/772e8/carmen-trio.png 200w", "/static/84318e11da87e4d6710731be386c38e8/e17e5/carmen-trio.png 400w", "/static/84318e11da87e4d6710731be386c38e8/5a190/carmen-trio.png 800w", "/static/84318e11da87e4d6710731be386c38e8/c1b63/carmen-trio.png 1200w", "/static/84318e11da87e4d6710731be386c38e8/8698d/carmen-trio.png 1239w"],
            "sizes": "(max-width: 800px) 100vw, 800px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      